var React = require('react');

function IconArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M122.85 61.43a61.39 61.39 0 01-61.43 61.41A61.38 61.38 0 010 61.45 61.35 61.35 0 0161.43 0a61.34 61.34 0 0161.38 61.4zM61.44 28.67L30.48 63h19.77v23.92h22.37V63H92.4l-31-34.32z"}));
}

IconArrow.defaultProps = {"className":"scroll__btn--arrow","aria-label":"sipka na horu","fill":"#be5944","viewBox":"0 0 122.88 122.88"};

module.exports = IconArrow;

IconArrow.default = IconArrow;
